const listeners = new Set<() => void>();

export const readStored = (storageKey: string | null) => {
  if (!storageKey) return null;

  try {
    return localStorage.getItem(storageKey);
  } catch {
    return null;
  }
};

export const writeStored = (storageKey: string, value: string) => {
  try {
    localStorage.setItem(storageKey, value);
  } catch {
    return false;
  }
  listeners.forEach(listener => listener());
  return true;
};

export const subscribeToStored = (listener: () => void) => {
  listeners.add(listener);
  window.addEventListener("storage", listener);
  return () => {
    listeners.delete(listener);
    window.removeEventListener("storage", listener);
  };
};
